import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicDiscount({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.2 1.25H8.55c-.46 0-.89.2-1.18.55l-5.7 5.7a1.53 1.53 0 000 2.1l4.73 4.74c.55.55 1.55.55 2.1 0l5.8-5.81c.28-.28.44-.65.45-1.05V2.7l-.02-.07v-.06a1.54 1.54 0 00-1.53-1.32zM2.74 8.55l5.79-5.79h.01l4.66-.01h.03l.01.02.01.03v4.66l-5.8 5.8-4.71-4.7zM11 4a1 1 0 110 2 1 1 0 010-2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicDiscount.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicDiscount.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicDiscount svgRef={ref} {...props} />);
export default ForwardRef;
